import React from 'react';

import StandardModal from '@/components/commons/StandardModal';

import ModalHeader from './ModalHeader';
import ModalBody from './ModalBody';
import style from './MyNetwork.module.css';

function ContactModal({
    isModalOpen, setIsModalOpen, data,
}) {
    if (!data) {
        return null;
    }
    const classNames = {
        modal: `min-w-[90vw] max-w-[90vw] mx-0 my-4 md:mx-4 md:max-w-[1100px] md:min-w-[1100px] bg-cirrusWhite rounded-lg p-0 ${style.scrollBar}`,
        closeButton: 'hidden',
    };

    return (
        <div className="flex items-center justify-center w-full">
            <StandardModal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                headline={null}
                classNames={classNames}
                styles={null}
            >
                <div className="w-full bg-cirrusWhite rounded-xl">
                    <ModalHeader
                        setIsModalOpen={setIsModalOpen}
                        data={data.contactData}
                    />
                    <ModalBody
                        data={data.contactData}
                        lastInteraction={data.lastInteraction}
                    />
                </div>
            </StandardModal>
        </div>
    );
}

export default ContactModal;
